import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkConfig } from '../../store';
import { IMachineNote } from '../types';
import { createMachineNote, ICreateMachineNoteInput } from '../../../service/graphql/machine-notes/createMachineNote';
import { getMachineThunk } from './getMachineThunk';

export const createMachineNoteThunk = createAsyncThunk<IMachineNote, ICreateMachineNoteInput, AsyncThunkConfig>(
  'machineNote/createNote',
  async (noteData, { getState, dispatch }) => {
    const {
      launchDarkly,
      selectedAccount: { activeAccountId },
    } = getState();

    if (!activeAccountId) {
      throw new Error('No accounts or user found.');
    }

    const result = await createMachineNote(launchDarkly.data, noteData);
    await dispatch(getMachineThunk(noteData.deviceId));
    return result;
  },
);
